import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadBtkreisflstmrelListStatus: 'idle',
    loadBtkreisflstmrelListError: undefined as any,
    loadBtkreisflstmrelListLastArgs: undefined as any,
    loadBtkreisflstmrelStatus: 'idle',
    loadBtkreisflstmrelError: undefined as any,
    saveBtkreisflstmrelStatus: 'idle',
    saveBtkreisflstmrelError: undefined as any,
    deleteBtkreisflstmrelStatus: 'idle',
    deleteBtkreisflstmrelError: undefined as any,

    btkreisflstmrelList: [] as any[],
    btkreisflsmtrel: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadBtkreisflstmrelList = createAsyncThunk('btkreisflstmrelSlice/loadBtkreisflstmrelList', async ({ parentModel, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().btkreisflstmrelSlice.loadBtkreisflstmrelListLastArgs
    if (_.isEqual(lastArgs, { parentModel }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/btkreisflstmrel/action=gte&min_BtKreisId=${parentModel.HDR_ID}&max_BtKreisId=${parentModel.HDR_ID}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { parentModel }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadBtkreisflstmrelListStatus } = getState().btkreisflstmrelSlice
        return loadBtkreisflstmrelListStatus !== 'pending'
    }
})

export const loadBtkreisflstmrel = createAsyncThunk('btkreisflstmrelSlice/loadBtkreisflstmrel', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/btkreisflstmrel/action=eql&HDR_ID=${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadBtkreisflstmrelStatus } = getState().btkreisflstmrelSlice
        return loadBtkreisflstmrelStatus !== 'pending'
    }
})

export const saveBtkreisflstmrel = createAsyncThunk('btkreisflstmrelSlice/saveBtkreisflstmrel', async ({ btkreisflstmrel }: any, { rejectWithValue }: any) => {
    let promises = []
    if (btkreisflstmrel?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/btkreisflstmrel/${ btkreisflstmrel?.HDR_ID }/`,
            prepareData(btkreisflstmrel),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/btkreisflstmrel/`,
            prepareData(btkreisflstmrel),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveBtkreisflstmrelStatus } = getState().btkreisflstmrelSlice
        return saveBtkreisflstmrelStatus !== 'pending'
    }
})

export const deleteBtkreisflstmrel = createAsyncThunk('btkreisflstmrelSlice/deleteBtkreisflstmrel', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/btkreisflstmrel/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteBtkreisflstmrelStatus } = getState().btkreisflstmrelSlice
        return deleteBtkreisflstmrelStatus !== 'pending'
    }
})

const BtkreisflstmrelSlice = createSlice({
    name: 'btkreisflstmrelSlice',
    initialState,
    reducers: {
        resetloadBtkreisflstmrelListError: (state) => {
            state.loadBtkreisflstmrelListError = undefined
        },
        resetloadBtkreisflstmrel: (state) => {
            state.btkreisflsmtrel = undefined
            state.loadBtkreisflstmrelError = undefined
        },
        resetloadBtkreisflstmrelError: (state) => {
            state.loadBtkreisflstmrelError = undefined
        },
        resetsaveBtkreisflstmrel: (state) => {
            state.btkreisflsmtrel = undefined
            state.saveBtkreisflstmrelError = undefined
        },
        resetsaveBtkreisflstmrelError: (state) => {
            state.saveBtkreisflstmrelError = undefined
        },
        resetdeleteBtkreisflstmrelError: (state) => {
            state.deleteBtkreisflstmrelError = undefined
        },
        removeFromBtkreisflstmrelListById: (state, action) => {
            state.btkreisflstmrelList = state.btkreisflstmrelList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromBtkreisflstmrelListByIds: (state, action) => {
            state.btkreisflstmrelList = state.btkreisflstmrelList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.btkreisflstmrelList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadBtkreisflstmrelListStatus = 'preloaded'
            state.loadBtkreisflstmrelListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.btkreisflstmrelList = []
            state.loadBtkreisflstmrelListStatus = 'idle'
            state.loadBtkreisflstmrelListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadBtkreisflstmrelList.pending, (state) => {
            state.loadBtkreisflstmrelListStatus = 'pending'
            state.loadBtkreisflstmrelListError = undefined
        })
        builder.addCase(loadBtkreisflstmrelList.fulfilled, (state, action) => {
            state.loadBtkreisflstmrelListStatus = 'idle'

            if (!action.payload) { return }

            state.loadBtkreisflstmrelListLastArgs = action.payload.args

            {
                state.btkreisflstmrelList = action.payload.data

            }
        })
        builder.addCase(loadBtkreisflstmrelList.rejected, (state, action) => {
            state.loadBtkreisflstmrelListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadBtkreisflstmrelListError = action.error.message
            } else {
                state.loadBtkreisflstmrelListError = action.payload
            }
        })

        builder.addCase(loadBtkreisflstmrel.pending, (state) => {
            state.loadBtkreisflstmrelStatus = 'pending'
            state.loadBtkreisflstmrelError = undefined
        })
        builder.addCase(loadBtkreisflstmrel.fulfilled, (state, action) => {
            state.loadBtkreisflstmrelStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.btkreisflsmtrel = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.btkreisflstmrelList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.btkreisflstmrelList.push(newItem) }
                else { state.btkreisflstmrelList[i] = { ...state.btkreisflstmrelList[i], ...newItem } }
            }
        })
        builder.addCase(loadBtkreisflstmrel.rejected, (state, action) => {
            state.loadBtkreisflstmrelStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadBtkreisflstmrelError = action.error.message
            } else {
                state.loadBtkreisflstmrelError = action.payload
            }
        })

        builder.addCase(saveBtkreisflstmrel.pending, (state) => {
            state.saveBtkreisflstmrelStatus = 'pending'
            state.saveBtkreisflstmrelError = undefined
        })
        builder.addCase(saveBtkreisflstmrel.fulfilled, (state, action) => {
            state.saveBtkreisflstmrelStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.btkreisflsmtrel = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.btkreisflstmrelList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.btkreisflstmrelList.push(newItem) }
                else { state.btkreisflstmrelList[i] = { ...state.btkreisflstmrelList[i], ...newItem } }
            }
        })
        builder.addCase(saveBtkreisflstmrel.rejected, (state, action) => {
            state.saveBtkreisflstmrelStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveBtkreisflstmrelError = action.error.message
            } else {
                state.saveBtkreisflstmrelError = action.payload
            }
        })

        builder.addCase(deleteBtkreisflstmrel.pending, (state) => {
            state.deleteBtkreisflstmrelStatus = 'pending'
            state.deleteBtkreisflstmrelError = undefined
        })
        builder.addCase(deleteBtkreisflstmrel.fulfilled, (state, action) => {
            state.deleteBtkreisflstmrelStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.btkreisflstmrelList = state.btkreisflstmrelList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.btkreisflstmrelList = state.btkreisflstmrelList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteBtkreisflstmrel.rejected, (state, action) => {
            state.deleteBtkreisflstmrelStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteBtkreisflstmrelError = action.error.message
            } else {
                state.deleteBtkreisflstmrelError = action.payload
            }
        })

    }
})

export const {
    resetloadBtkreisflstmrelListError,
    resetloadBtkreisflstmrel,
    resetloadBtkreisflstmrelError,
    resetsaveBtkreisflstmrel,
    resetsaveBtkreisflstmrelError,
    resetdeleteBtkreisflstmrelError,
    removeFromBtkreisflstmrelListById,
    removeFromBtkreisflstmrelListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = BtkreisflstmrelSlice.actions
export default BtkreisflstmrelSlice.reducer
